<template>
  <div>

    <Loader :visible="isLoading" :text="loadingText" />


    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>

      <ConfirmationModal :show="showBarCodeModal" @close="showBarCodeModal = false">
        <template #title>
            {{ $t('core.item_search') }}
        </template>

        <template #content>
          <div v-if="singlebarcode">
            {{ $t('gm.scan_barcode_to_increment') }} {{ itemRef?.Item }} <br>
            <input 
                v-model="tmpQty" 
                class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                disabled 
                type="number"
                min="0"
                :max="itemRef ? Number(itemRef.Qty) - Number(itemRef.DeliveredQty || 0) : undefined"
            >
            ({{ itemRef?.Qty }} {{ $t('core.in_order') }}.)
          </div>
          <div v-else>
            {{ $t('core.qty_received_of') }} {{ itemRef?.Item }} <br>
            <input 
              v-model="tmpQty"
              class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
              onfocus="this.select()" 
              type="number" 
              ref="barcodeQtyInput"
              min="0"
              placeholder="0"
              :max="itemRef ? Number(itemRef.Qty) - Number(itemRef.DeliveredQty || 0) : undefined"
            >
            ({{ itemRef ? Number(itemRef.Qty) - Number(itemRef.DeliveredQty || 0) : undefined }} per completare ordine fornitore.)
          </div>
        </template>

        <template #footer>
            <SecondaryButton @click="showBarCodeModal = false">
                {{ $t('actions.cancel') }}
            </SecondaryButton>

            <PrimaryButton
                class="ms-3"
                @click="commitModalQty"
            >
                {{ $t('core.set') }}
            </PrimaryButton>
        </template>
    </ConfirmationModal>
    <ConfirmationModal :show="showSaveModal" @close="showSaveModal = false">
      <template #title>
          {{ useExcelDDTFlow ? $t('gm.ddt_flow.confirm_title') : $t('core.confirm_receive') }}
      </template>

      <template #content>
        <div v-if="useExcelDDTFlow" class="space-y-4">
          <div class="bg-blue-50 border border-blue-200 rounded-md p-4">
            <p class="text-sm font-medium text-blue-800 mb-2">{{ $t('gm.ddt_flow.bills_to_create') }}</p>
            <div class="space-y-1">
              <span v-for="ddt in ddtsForSave" :key="ddt" class="block text-sm text-blue-700">
                • DDT: <strong>{{ ddt }}</strong>
              </span>
            </div>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ $t('gm.supplier_doc_date') }}: 
            </label>
            <VueDatePicker 
                        v-model="supplierDate"                   
                        model-type="yyyy-MM-dd"
                        :locale="$t('ui.datepicker_locale')"
                        :format="$t('ui.datepicker_format')"
                        :placeholder="$t('ui.choose_date')"
                        :enable-time-picker="false"
                        class="border rounded-md w-full"
                        text-input
                        auto-apply
                        
            ></VueDatePicker>
          </div>
        </div>

        <div v-else class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ $t('core.document') }} {{ $t('core.supplier').toLowerCase() }}: 
            </label>
            <input v-model="supplierDoc" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ $t('gm.supplier_doc_date') }}: 
            </label>
            <VueDatePicker 
                        v-model="supplierDate"                   
                        model-type="yyyy-MM-dd"
                        :locale="$t('ui.datepicker_locale')"
                        :format="$t('ui.datepicker_format')"
                        :placeholder="$t('ui.choose_date')"
                        :enable-time-picker="false"
                        class="border rounded-md w-full"
                        text-input
                        auto-apply
                        
            ></VueDatePicker>
          </div>
        </div>


        <div class="mt-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ $t('gm.bill_of_lading_date') }}: 
            </label>
            <VueDatePicker 
                        v-model="BillofLadingDate"                   
                        model-type="yyyy-MM-dd"
                        :locale="$t('ui.datepicker_locale')"
                        :format="$t('ui.datepicker_format')"
                        :placeholder="$t('ui.choose_date')"
                        :enable-time-picker="false"
                        class="border rounded-md w-full"
                        text-input
                        auto-apply
                        :min-date="supplierDate ? (supplierDate instanceof Date ? supplierDate : new Date(supplierDate)) : new Date()"
            ></VueDatePicker>
          </div>

        </div>
      </template>

      <template #footer>
          <SecondaryButton @click="showSaveModal = false">
              {{ $t('actions.cancel') }}
          </SecondaryButton>
          <PrimaryButton
            v-if="positioningMode"
            class="ms-3"
            @click="Save(true)"
            :disabled="saveDone"
          >
            {{ $t('core.save') }} e Posiziona
          </PrimaryButton>
          <PrimaryButton
            class="ms-3"
            @click="Save(false)"
            :disabled="saveDone"
          >
            {{ $t('core.save') }}
          </PrimaryButton>
      </template>
    </ConfirmationModal>
    <ConfirmationModal :show="showQtyDiffModal" @close="showQtyDiffModal = false">
      <template #title>
        {{ $t('gm.confirm_mismatched_quantities') }}
      </template>
      <template #content>
        {{ $t('gm.confirm_mismatched_quantities_description') }}
        <ul class="mt-2 text-xs text-gray-600">
          <li v-for="row in qtyDiffRows" :key="row.Item">
            {{ $t('core.order') }}: {{ row.InternalOrdNo || row.PurchaseOrdId }}, {{ $t('core.item') }}: {{ row.Item }}<br>
            {{ $t('core.qty_order') }}: {{ row.Qty }}, {{ $t('core.qty_registered') }}: {{ row.DeliveredQty }}, {{ $t('core.qty_to_register') }}: {{ row.CommitQty }}
          </li>
        </ul>
      </template>
      <template #footer>
        <SecondaryButton @click="showQtyDiffModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton class="ms-3" @click="showQtyDiffModal = false; showSaveModal = true;">
          {{ $t('actions.confirm_and_save') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>
    <ConfirmationModal :show="showExcessSupplierModal" @close="showExcessSupplierModal = false">
        <template #title>
            Assegna fornitore eccedenza
        </template>
        <template #content>
          <p class="text-sm text-gray-600 mb-3">
            L'articolo <strong>{{ pendingExcess?.itemCode }}</strong> è in eccedenza rispetto agli ordini selezionati.
            Scegli a quale fornitore assegnare questa eccedenza:
          </p>
          <select
            v-model="excessSupplierChoice"
            class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option v-for="s in suppliersForItem(pendingExcess?.itemCode)" :key="s.Supplier" :value="s.Supplier">
              {{ s.CompanyName }}
            </option>
          </select>
        </template>
        <template #footer>
            <PrimaryButton class="ms-3" @click="confirmExcessSupplierChoice">
                {{ $t('core.set') }}
            </PrimaryButton>
        </template>
    </ConfirmationModal>
    <ConfirmationModal :show="showExceedModal" @close="showExceedModal = false">
        <template #title>
            {{ $t('core.warning') }}
        </template>
        <template #content>
          <div class="mb-2">
              <strong>{{ itemRef?.Item }}</strong> - {{ itemRef?.Description }}
          </div>
            {{ $t('gm.qty_exceeds_order', { item: itemRef?.Item, max: (itemRef?.Qty - itemRef?.DeliveredQty) }) }}
        </template>
        <template #footer>
            <SecondaryButton @click="showExceedModal = false">
                {{ $t('actions.cancel') }}
            </SecondaryButton>
            <PrimaryButton class="ms-3" @click="confirmExceedModal">
                {{ $t('actions.confirm') }}
            </PrimaryButton>
        </template>
    </ConfirmationModal>
    
    <ConfirmationModal :show="showInfoModal" @close="showInfoModal = false">
      <template #title>
          <span :class="{
              'text-green-600': modalType === 'success',
              'text-red-600': modalType === 'error',
              'text-yellow-600': modalType === 'warning',
              'text-blue-600': modalType === 'info'
          }">
              <i class="fa mr-2" :class="{
                  'fa-check-circle': modalType === 'success',
                  'fa-exclamation-triangle': modalType === 'error' || modalType === 'warning',
                  'fa-info-circle': modalType === 'info'
              }"></i>
              {{ modalTitle }}
          </span>
      </template>

      <template #content>
          <div class="p-4">
              <p class="text-gray-700 text-lg whitespace-pre-line">{{ modalMessage }}</p>
          </div>
      </template>

      <template #footer>
          <PrimaryButton @click="showInfoModal = false">
              {{ $t('actions.ok') }}
          </PrimaryButton>
      </template>
    </ConfirmationModal>
    <ConfirmationModal :show="showDDTAssignmentModal" @close="showDDTAssignmentModal = false">
      <template #title>
        {{ $t('gm.ddt_flow.assignment_title') }}
      </template>

      <template #content>
        <div class="space-y-4">
          <p class="text-sm text-gray-700">
            {{ $t('gm.ddt_flow.assignment_description') }}
          </p>
          
          <div class="space-y-3 max-h-80 overflow-y-auto">
            <div v-for="item in orphanItems" :key="item.id_riga_portale" class="border rounded-md p-3 bg-gray-50">
              <div class="text-sm font-medium text-gray-800 mb-2">
                {{ item.item }} - {{ item.description }} ({{ $t('core.qty') }}: {{ item.qty }})
              </div>
              
              <div class="flex gap-2">
                <select 
                  v-model="ddtAssignments[item.id_riga_portale]"
                  class="flex-1 p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">{{ $t('gm.ddt_flow.choose_ddt') }}</option>
                  <option v-for="ddt in availableDDTs" :key="ddt" :value="ddt">
                    {{ ddt }}
                  </option>
                </select>
                
                <input 
                  v-model="ddtAssignments[item.id_riga_portale]"
                  type="text"
                  :placeholder="$t('gm.ddt_flow.insert_ddt_placeholder')"
                  class="flex-1 p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
          <SecondaryButton @click="showDDTAssignmentModal = false">
              {{ $t('actions.cancel') }}
          </SecondaryButton>
          <PrimaryButton 
            class="ms-3"
            @click="completeDDTAssignment"
          >
            {{ $t('gm.ddt_flow.continue_save') }}
          </PrimaryButton>
      </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showBomModal" @close="showBomModal = false" max-width="5xl">
      <template #title>
        Scarico Componenti Distinta Base
      </template>
      <template #content>
        <div class="space-y-4">
          <p class="text-sm text-gray-600">
            I seguenti articoli hanno componenti in distinta base. Verifica e conferma le quantità da scaricare.
          </p>
          <div class="max-h-[65vh] overflow-y-auto space-y-4">
            <div v-for="group in bomRows" :key="group.item" class="border rounded-md p-3 bg-gray-50">
              <div class="text-sm font-semibold text-gray-800 mb-2">
                {{ group.item }}
                <span v-if="group.description" class="font-normal text-gray-600"> – {{ group.description }}</span>
                <span class="font-normal text-gray-500 ml-2">(Q.tà ricevuta: {{ group.totalQty }})</span>
              </div>
              <div class="overflow-x-auto">
                <table class="w-full text-xs border-collapse">
                  <thead>
                    <tr class="bg-gray-100 text-gray-600 border-b border-gray-200">
                      <th class="text-left px-3 py-2 font-semibold">
                        Componente
                      </th>
                      <th class="text-left px-3 py-2 font-semibold">
                        Descrizione
                      </th>
                      <th class="text-right px-3 py-2 font-semibold w-24">
                        Coeff.
                      </th>
                      <th class="text-right px-3 py-2 font-semibold w-32">
                        Q.tà da scaricare
                      </th>
                      <th class="text-center px-3 py-2 font-semibold w-20">
                        Scarica
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="comp in group.components"
                      :key="comp.component"
                      class="border-b border-gray-100 transition-colors hover:bg-gray-50"
                      :class="{ 'opacity-50 bg-gray-50': !comp.confirmed }"
                    >
                      <td class="px-3 py-2">
                        <span class="font-mono font-medium text-gray-800">
                          {{ comp.component }}
                        </span>
                      </td>
                      <td class="px-3 py-2">
                        <span class="font-mono font-medium text-gray-800">
                          {{ comp.description || 'N/A' }}
                        </span>
                      </td>


                      <td class="text-right px-3 py-2 tabular-nums text-gray-600">
                        {{ comp.coefficient }}
                      </td>

                      <td class="px-3 py-2">
                        <input
                          v-model.number="comp.dischargeQty"
                          type="number"
                          min="0"
                          step="any"
                          :disabled="!comp.confirmed"
                          class="w-full px-2 py-1.5 text-right tabular-nums border border-gray-300 rounded-md text-xs
                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                                disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
                          @focus="$event.target.select()"
                        >
                      </td>

                      <td class="text-center px-3 py-2">
                        <input
                          v-model="comp.confirmed"
                          type="checkbox"
                          class="w-4 h-4 rounded border-gray-300 text-blue-600
                                focus:ring-2 focus:ring-blue-500 cursor-pointer"
                        >
                      </td>
                    </tr>

                    <tr v-if="!group.components || group.components.length === 0">
                      <td
                        colspan="4"
                        class="px-3 py-5 text-center text-gray-400"
                      >
                        Nessun componente disponibile
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <SecondaryButton @click="showBomModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton class="ms-3" @click="confirmBomModal">
          Conferma e continua
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showPrintPickingModal" @close="showPrintPickingModal = false">
      <template #title>
          {{ $t('gm.print_pickings') || 'Stampa Picking Generati' }}
      </template>
      
      <template #content>
        <div class="mt-4">
            <p class="mb-4 text-sm text-gray-600">Operazione completata. Puoi stampare i documenti generati:</p>
            <ul class="divide-y divide-gray-200 border rounded-md">
              <li v-for="(picking, index) in generatedPickings" :key="index" 
                class="flex items-center justify-between p-4 bg-white border-b last:border-0 hover:bg-gray-50 transition-all duration-200">
                
                <!-- Info Documento -->
                <div class="flex flex-col gap-0.5">
                    <span class="text-[10px] font-bold text-blue-600 uppercase tracking-wider">Documento Generato</span>
                    <span class="text-sm font-medium text-gray-800">{{'Doc. No: '+ picking.DocumentNumber + ' Picking Id: ' + picking.DocumentId }}</span>
                </div>

                <!-- Gruppo Pulsanti Stampa -->
                <div class="flex items-center gap-3">
                    <!-- Pulsante Etichetta (Stile Primario) -->
                    <button 
                        @click="printLabelPicking(picking)" 
                        class="inline-flex items-center gap-2 px-2 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-md shadow-sm transition-all active:scale-95 group"
                        title="Stampa Etichetta"
                    >
                        <v-icon name="co-print" scale="0.8" class="opacity-90 group-hover:scale-110 transition-transform" />
                        <span>Etichetta</span>
                    </button>

                    <!-- Pulsante Picking List (Stile Light/Bordato) -->
                    <button 
                        @click="printPicking(picking)" 
                        class="inline-flex items-center gap-2 px-2 py-2 bg-white hover:bg-gray-100 text-gray-700 border border-gray-300 text-xs font-semibold rounded-md shadow-sm transition-all active:scale-95 group"
                        title="Stampa Lista"
                    >
                        <v-icon name="co-print" scale="0.8" class="text-gray-400 group-hover:text-gray-600 transition-colors" />
                        <span>Picking List</span>
                    </button>
                </div>
              </li>
            </ul>
        </div>
      </template>

      <template #footer>
        <SecondaryButton @click="handleModalClose">
            {{ $t('core.close_and_continue') || 'Chiudi e prosegui' }}
        </SecondaryButton>
    </template>
    </ConfirmationModal>



    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-2">
        <h2 class="text-lg font-semibold">{{ $t('core.order_details') }} {{ $t('core.supplier') }}:</h2>
        <button
          class="sm:hidden flex items-center gap-1 text-sm px-3 py-1.5 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors"
          @click="$inertia.visit(route('modules.gm.ricezione'))"
        >
          <i class="fa fa-arrow-left text-xs"></i>
          Indietro
        </button>
      </div>
      <ul class="mb-4 text-sm">
        <li
          v-for="order in displayedOrderList"
          :key="order"
          class="inline-block mr-2 bg-blue-100 rounded px-3 py-1 mb-1"
          :class="infoOrdiniActive ? 'hover:bg-blue-200 cursor-pointer text-blue-700 font-medium' : ''"
          @click="infoOrdiniActive && openInfoOrdini('order', order)"
        >{{ order }}</li> 
        <li v-if="orderList.length > 9" @click="isOrderListExpanded = !isOrderListExpanded" class="inline-block mr-2 bg-blue-100 hover:bg-blue-200 rounded px-3 py-1 mb-1 cursor-pointer font-bold select-none" :title="isOrderListExpanded ? 'Mostra meno' : 'Mostra tutti'">
          {{ isOrderListExpanded ? '<<' : '...' }}
        </li>
      </ul>
      <div v-if="!isDisabledMode" class="mb-6">
        <div class="relative">
          <div class="relative w-full inline-flex items-center">
              <input class="pl-3 py-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 pr-10 text-base" 
              type="text" 
              ref="barcodeInput"
              v-model="barcodeSearch" 
              :placeholder="$t('core.barcode_search') + '...'" 
              @keyup.enter="searchItemfromBarcode"
              autofocus
              :inputmode="mode"
            />
              <span class="absolute right-3 cursor-pointer" v-if="noPopupBarcode" @click="mode = mode === 'none' ? 'text' : 'none'"><v-icon name="fa-keyboard" scale="1.5" :class="mode === 'text' ? 'text-blue-500' : 'text-gray-500'" /></span>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium">{{ $t('core.items_list') }}</label>
      </div>
      <PageNormalTable
        :headers="headers" 
        :items="items" 
        :sort-by="sortby" 
        item-value= "id_riga_portale"
        :row-props="getRowProps"
        hide-default-footer
        multi-sort
        :mobile-filter-exclusions="['Qty', 'DeliveredQty', 'CommitQty', 'Lot', 'Riferimento', 'Status']"
        @item-selected="focusBarcodeInput"
        @updated="rewriteReferenceLabels"
        >
        <template #item.InternalOrdNo="{ item }">
          <span
            v-if="infoOrdiniActive"
            class="text-blue-600 hover:underline cursor-pointer font-medium"
            @click="openInfoOrdini('order', item.InternalOrdNo)"
          >{{ item.InternalOrdNo }}</span>
          <span v-else>{{ item.InternalOrdNo }}</span>
        </template>

        <template #item.Item="{ item }">
          <span
            v-if="infoOrdiniActive"
            class="text-blue-600 hover:underline cursor-pointer font-medium"
            @click="openInfoOrdini('item', item.Item)"
          >{{ item.Item }}</span>
          <span v-else>{{ item.Item }}</span>
        </template>

        <template #item.UnitValue="{ item }">
          <div class="flex items-center justify-end gap-2 whitespace-nowrap">
            <span>{{ item.UnitValue == null ? '—' : formatNumberDisplay(item.UnitValue, 2) }}</span>
            <v-menu location="bottom end">
              <template #activator="{ props }">
                <button
                  v-bind="props"
                  type="button"
                  class="inline-flex items-center justify-center rounded-full p-1 text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  :aria-label="`Dettagli prezzo ${item.Item}`"
                  :title="`Dettagli prezzo ${item.Item}`"
                  @click.stop
                >
                  <v-icon name="bi-info-circle" scale="1.1" />
                </button>
              </template>
              <div class="w-72 max-w-[90vw] rounded-md border border-gray-200 bg-white p-4 text-sm shadow-lg">
                <div class="mb-3 border-b border-gray-100 pb-2">
                  <div class="font-semibold text-gray-800">Dettaglio prezzo</div>
                  <div class="text-xs text-gray-500">{{ item.Item }} — {{ item.Description }}</div>
                </div>
                <dl class="space-y-2">
                  <div class="flex justify-between gap-4">
                    <dt class="text-gray-600">Prezzo unitario</dt>
                    <dd class="text-right font-medium text-gray-800">{{ item.UnitValue == null ? '—' : formatNumberDisplay(item.UnitValue, 2) }}</dd>
                  </div>
                  <div class="flex justify-between gap-4">
                    <dt class="text-gray-600">Sconto</dt>
                    <dd class="text-right font-medium text-gray-800">{{ item.DiscountFormula || '—' }}</dd>
                  </div>
                  <div class="flex justify-between gap-4">
                    <dt class="text-gray-600">Imponibile</dt>
                    <dd class="text-right font-medium text-gray-800">{{ item.TaxableAmount == null ? '—' : formatNumberDisplay(item.TaxableAmount, 2) }}</dd>
                  </div>
                  <div class="flex justify-between gap-4">
                    <dt class="text-gray-600">Codice IVA</dt>
                    <dd class="text-right font-medium text-gray-800">{{ item.TaxCode || '—' }}</dd>
                  </div>
                  <div class="flex justify-between gap-4 border-t border-gray-100 pt-2">
                    <dt class="font-semibold text-gray-700">Totale</dt>
                    <dd class="text-right font-semibold text-gray-900">{{ item.TotalAmount == null ? '—' : formatNumberDisplay(item.TotalAmount, 2) }}</dd>
                  </div>
                </dl>
              </div>
            </v-menu>
          </div>
        </template>
        
        <template #item.Status="{ item }">
            <div class="flex justify-end sm:justify-center items-center">
                <!-- 3) Anomalia: Ordine Già Evaso -->
                <i v-if="item.SaleOrdIsPicked" 
                  class="fa fa-times-circle text-red-500 text-xl" 
                  title="ERRORE: Ordine cliente già evaso/chiuso"></i>

                <!-- 1) Picking parziale presente -->
                <i v-else-if="item.SaleOrdPickedQty > 0" 
                  class="fa fa-truck text-blue-500 text-xl" 
                  :title="'Picking parziale esistente: ' + item.SaleOrdPickedQty"></i>

                <!-- 2) Qta in eccesso -->
                <i v-else-if="item.CommitQty > item.SaleOrdRemaining" 
                  class="fa fa-exclamation-circle text-orange-500 text-xl" 
                  title="Attenzione: Quantità superiore al residuo ordine cliente"></i>

                <i v-else-if="item.CommitQty > (item.Qty - item.DeliveredQty)" 
                  class="fa fa-exclamation-triangle text-yellow-500 text-xl" 
                  title="Attenzione: Quantità superiore al residuo ordine fornitore"></i>

                <i v-else-if="item.CommitQty == 0" 
                  class="fa fa-minus-circle text-gray-400 text-xl" 
                  title="Non ancora registrato"></i>
                <!-- 4) Tutto OK -->
                <i v-else class="fa fa-check-circle text-green-500 text-xl" title="OK"></i>
            </div>
        </template>
        <template #item.CommitQty="{ item }">
            <span class="block my-1">
                <input 
                  type="number" 
                  class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right" 
                  v-model="item.CommitQty"
                  @change="handleTableQtyChange(item)"  
                  onfocus="this.select()"
                  min="0"
                  :max="item.Qty - (item.DeliveredQty || 0)"
                  >
            </span>
        </template>
        <template #item.Riferimento="{ item }">
          <span class="px-2 py-1 text-sm text-gray-700">
            <span> {{ [item.customer_id, item.SaleOrdNo, item.sale_ord_priority, item.Bin, item.jobDetails || item.Job].filter(x => x).join(' - ') }} </span>
          </span>
        </template>
        <template #item.Lot="{ item }">
            
            <div v-if="handleLots && parseInt(item.UseLots) === 1" class="flex gap-1 m-1">
              <button 
                    @click="generateLot(item)" 
                    class="px-3 py-2 m-1 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors" 
                    :title="$t('core.generate_lot')"
                >
                    <i class="fa fa-magic"></i>
              </button>  
              <input type="text" placeholder="Lotto" class="flex-1 min-w-0 px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.Lot" @change="debouncedSaveTempData()">
              
            </div>
            <div v-else>
              {{ $t('gm.item_not_managed_by_lots') }}
            </div>
            <div v-if="handleLots && setValidityLotDate && parseInt(item.UseLots) === 1" class="w-full">
              <VueDatePicker 
                v-model="item.ValidTo"                   
                model-type="yyyy-MM-dd"
                :locale="$t('ui.datepicker_locale')"
                :format="$t('ui.datepicker_format')"
                :placeholder="$t('ui.choose_expired')"
                :enable-time-picker="false"
                class="flex-1 min-w-0 m-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                text-input
                auto-apply
                teleport
                @update:model-value="debouncedSaveTempData()"
              ></VueDatePicker>
            </div>
            <div v-if="handleLots && usaMatricola && parseInt(item.UseLots) === 1" class="flex gap-1 m-1 ">
              <input type="text" placeholder="matricola" class="flex-1 min-w-0 px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.Matricola" @change="debouncedSaveTempData()">
            </div>
            <div v-else>
              -
            </div>
        </template>
      </PageNormalTable>

      <div v-if="excessItems.length > 0" class="mt-10 border-t pt-6">

        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold">⚠️ {{ $t('gm.excess_items') }}</h3>
          <button 
              @click="clearExcessTable"
              class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors text-sm"
          >
              <i class="fa fa-trash mr-2"></i> {{ $t('gm.clear_all') }}
          </button>
        </div>
        <PageNormalTable
            :headers="excessHeadersComputed"
            :items="excessItems"
            :row-props="getExcessRowProps"
            hide-default-footer
        >
          <template #item.Riferimento="{ item }">
              <span class="px-2 py-1 text-sm text-gray-700">{{ item.Riferimento }}</span>
          </template>
          <template #item.Supplier="{ item }">
              <span class="px-2 py-1 text-sm text-gray-700">
                {{ distinctSuppliers.find(s => s.Supplier === item.Supplier)?.CompanyName || item.Supplier }}
              </span>
          </template>
          <template #item.CommitQty="{ item }">
              <span>
                  <input type="number" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.CommitQty" onfocus="this.select()" @change="debouncedSaveTempData()">
              </span>
          </template>
          <template #item.Lot="{ item }">
              <div v-if="handleLots && parseInt(item.UseLots) === 1" class="flex gap-2">
                  <input type="text" class="flex-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.Lot" @change="debouncedSaveTempData()">
                  <button 
                      @click="generateLot(item)" 
                      class="px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors" 
                      :title="$t('core.generate_lot')"
                  >
                      <i class="fa fa-magic"></i>
                  </button>
              </div>
              <div v-else>
                {{ $t('gm.item_not_managed_by_lots') }}
              </div>
          </template>
          <template #item.ValidTo="{ item }">
              <div v-if="handleLots && setValidityLotDate && parseInt(item.UseLots) === 1"  class="min-w-[30vh]">
                <VueDatePicker 
                  v-model="item.ValidTo"                   
                  model-type="yyyy-MM-dd"
                  :locale="$t('ui.datepicker_locale')"
                  :format="$t('ui.datepicker_format')"
                  :placeholder="$t('ui.choose_date')"
                  :enable-time-picker="false"
                  class="border rounded-md w-full px-3 py-2 text-sm"
                  text-input
                  auto-apply
                  @update:model-value="debouncedSaveTempData()"
                ></VueDatePicker>
              </div>
              <div v-else>
                -
              </div>
          </template>
          <template #item.actions="{ item }">
            <button 
                @click="removeExcessRow(item)"
                class="p-2 text-red-500 hover:text-red-700 transition-colors"
                title="Cancella riga"
            >
                <i class="fa fa-times"></i>
            </button>
          </template>
        </PageNormalTable>
      </div>
      <div class="pb-24"></div>
      <div class="fixed left-0 right-0 bottom-0 flex justify-center items-center pointer-events-none">
        <div class="flex gap-2 pointer-events-auto bg-white w-full px-4 py-3 justify-center">
             <button
              class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              @click="onConfermaClick"
              :disabled="!hasAtLeastOneCommit"
            >
              
              <template v-if="tempBolApproval === 2">Salva per Approvazione</template>
              <template v-else>
                {{pickingGenerationMode ? $t('gm.reg-confirm') + ' e Genera Picking' : $t('gm.reg-confirm') }}
                {{positioningMode ? ' - Posizionamento Attivo' : '' }}
              </template>
            </button>
        </div>
      </div>
    </div>
    <ToastNotification
    :show="toast.show"
    :message="toast.message"
    :type="toast.type"
    @update:show="toast.show = $event"
    />
  </div>
  
</template>

<script setup>
import { Link, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageNormalTable from '@/Components/PageNormalTable.vue';
import axios from 'axios';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';
import ToastNotification from '@/Components/ToastNotification.vue';
import Loader from '@/Components/Loader.vue';
</script>

<script>

const getTodayDateString = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export default {
  props: {
    items: Array,
    singlebarcode: Boolean,
    handleLots: Boolean,
    setValidityLotDate: { type: Boolean, default: false },
    lotConfig: {
      type: Object,
      default: () => ({
        prefix: '',
        year_format: 'none',
        separator: '-',
        suffix: ''
      })
    },
    defaultQtyMode: {
      type: String,
      default: 'standard'
    },
    barcodeMap: {
      type: Object,
      default: () => ({})
    },
    headers: Array,
    sortby: Array,   
    customer: Object,
    pickingGenerationMode: { type: Boolean, default: false },
    positioningMode: { type: Boolean, default: false },
    confirm_bin: { type: Boolean, default: false },
    required_bin: { type: Boolean, default: false },
    noPopupBarcode: { type: Boolean, default: false },
    initialSupplierDoc: { type: String, default: '' },
    useExcelDDTFlow: { type: Boolean, default: false },
    infoOrdiniActive: { type: Boolean, default: false },
    usaMatricola: { type: Boolean, default: false },
    tempBolApproval: { type: Number, default: 0 },
    initialExcessItems: { type: Array, default: () => [] },
    initialTempBolHash: { type: String, default: null }
  },
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    Loader,
    PageNormalTable,
    ToastNotification,
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('modules.ricezione-merce'), href: route('modules.gm.ricezione') }
      ],
      barcodeSearch: '',
      savedBarcode: '',
      tmpBarcode: '',
      showBarCodeModal: false,
      showSaveModal: false,
      saveDone: false,
      itemRef: undefined,
      tmpQty: 0,
      supplierDoc: this.initialSupplierDoc || '',
      supplierDate: getTodayDateString(),
      BillofLadingDate: getTodayDateString(),
      ipp: 10,
      page: 1,
      showQtyDiffModal: false,
      qtyDiffRows: [],
      showExceedModal: false,
      toast: {
        show: false,
        message: '',
        type: 'success'
      },
      isLoading: false,
      loadingText: '',
      highlightedRowIds: [], 
      excessItems: [...this.initialExcessItems],
      tempBolHash: this.initialTempBolHash,
      excessHeaders: [],
      highlightedExcessIds: [],
      errorMessage: '',
      showInfoModal: false,
      modalTitle: '',
      modalMessage: '',
      modalType: 'info', // 'success', 'error', 'warning'
      showPrintPickingModal: false,
      generatedPickings: [],
      mode: this.noPopupBarcode ? 'none' : 'text',
      isOrderListExpanded: false,
      showDDTAssignmentModal: false,
      orphanItems: [],
      availableDDTs: [],
      ddtAssignments: {},

      pendingRedirect: false,
      lastBollaId: null,
      showBomModal: false,
      bomRows: [],
      showExcessSupplierModal: false,
      pendingExcess: null,
      excessSupplierChoice: '',
      pendingQtyDiffRows: [],
      tempSaveTimer: null,
      toastTimer: null
    };
  },
  computed: {
    ddtsForSave() {
      const all = [...this.items, ...this.excessItems].filter(r => Number(r.CommitQty || 0) > 0 && r.DDT);
      return [...new Set(all.map(r => r.DDT))];
    },
    hasAtLeastOneCommit() {
      return this.items.some(row => Number(row.CommitQty || 0) > 0)
        || this.excessItems.some(row => Number(row.CommitQty || 0) > 0);
    },
    orderList() {
      return [...new Set(this.items.map(x => x.InternalOrdNo))];
    },
    distinctSuppliers() {
      const map = new Map();
      this.items.forEach(x => {
        if (x.Supplier && !map.has(x.Supplier)) {
          map.set(x.Supplier, { Supplier: x.Supplier, CompanyName: x.CompanyName || x.Supplier });
        }
      });
      return [...map.values()];
    },
    displayedOrderList() {
      if (this.isOrderListExpanded || this.orderList.length <= 9) {
        return this.orderList;
      }
      return this.orderList.slice(0, 9);
    },
    isDisabledMode() {
      return this.defaultQtyMode === 'disabled';
    },
    normalizedBarcodeMap() {
      const map = {};
      for (const key in this.barcodeMap) {
        map[key.trim().toUpperCase()] = this.barcodeMap[key];
      }
      return map;
    },
    excessHeadersComputed() {
      const headers = [
        { title: this.$t('core.item'), key: 'Item' },
        { title: this.$t('core.description'), key: 'Description' },
        { title: this.$t('core.reference'), key: 'Riferimento' },
        { title: this.$t('core.qty'), key: 'CommitQty' },
        { title: this.$t('core.lot'), key: 'Lot' },
      ];

      if (this.distinctSuppliers.length > 1) {
        headers.push({ title: this.$t('core.supplier'), key: 'Supplier' });
      }

      if (this.handleLots && this.setValidityLotDate) {
        headers.push({ title: this.$t('core.valid_to'), key: 'ValidTo' });
      }
      
      headers.push(
        { title: this.$t('core.uom'), key: 'UoM' },
        { title: this.$t('actions.actions'), key: 'actions', sortable: false }
      );
      
      return headers;
    }
  },
  methods: {

    showRequestError(error) {
      if (error?.response) {
        this.showToast(this.$t('core.error'), 'error', `${this.$t('core.server_error')} (${error.response.status})`);
      } else {
        this.showToast(this.$t('core.error'), 'error', this.$t('core.connection_error'));
      }
    },

    openInfoOrdini(type, value) {
      const params = new URLSearchParams();
      params.set('type', type);
      if (type === 'item') {
        params.set('item', value);
      } else {
        params.set('order_number', value);
      }
      window.open(route('modules.gm.infoordini') + '?' + params.toString(), '_blank');
    },

    searchItemfromBarcode() {
 
      if (!this.barcodeSearch || !this.barcodeSearch.trim()) return;
      const searchedUpper = this.barcodeSearch.trim().toUpperCase();
      let itemCode = this.normalizedBarcodeMap[searchedUpper];

      if (!itemCode) {
        const directMatch = this.items.find(x => x.Item && x.Item.trim().toUpperCase() === searchedUpper);
        if (directMatch) itemCode = directMatch.Item;
      }

      if (!itemCode) {
        const supplierCodeMatch = this.items.find(x => x.SupplierCode && x.SupplierCode.trim().toUpperCase() === searchedUpper);
        if (supplierCodeMatch) itemCode = supplierCodeMatch.Item;
      }

      // Articolo non presente in ordine
      if (!itemCode) {
        const searchedBarcode = this.barcodeSearch;
        axios.post(route('modules.gm.cercabarcode'), { barcode: searchedBarcode })
            .then((response) => {
                const results = response.data;
                if (results && results.length > 0) {
                    const foundItem = results[0];
                    this.showToast(this.$t('gm.item_found_not_in_order', { item: foundItem.Item, description: foundItem.Description }), 'error');
                } else {
                  this.showToast(this.$t('gm.item_not_found_in_system'), 'error', `${this.$t('gm.barcode_not_found')}: ${searchedBarcode}`);
                }
            })
            .catch((error) => {
              this.showRequestError(error);
            });
        this.barcodeSearch = '';
        return;
      }

      const orderLines = this.items.filter(x => x.Item == itemCode);

      // --- GESTIONE POLITICHE (CASI articolo presente in Ordine Fornitore) ---

      if (this.defaultQtyMode === 'increment') {
          // Cerca la prima riga d'ordine che ha ancora spazio residuo
          let target = orderLines.find(x => {
              let residuo = Number(x.Qty) - Number(x.DeliveredQty);
              return Number(x.CommitQty || 0) < residuo;
          });

          if (target) {
              // CASO 1: Incremento normale entro i limiti dell'ordine
              target.CommitQty = Number(target.CommitQty || 0) + 1;
              this.triggerHighlight(target);
          } else {
              // CASO 2: Tutte le righe d'ordine per questo articolo sono piene -> Eccedenza
              this.addToExcess(itemCode, 1);
          }

      } else if (this.defaultQtyMode === 'max') {
          // CASO 1: Riempie tutte le righe d'ordine disponibili per questo articolo
          let updatedAny = false;
          orderLines.forEach(line => {
              let residuo = Number(line.Qty) - Number(line.DeliveredQty);
              if (Number(line.CommitQty || 0) < residuo) {
                  line.CommitQty = residuo;
                  this.triggerHighlight(line);
                  updatedAny = true;
              }
          });
          
          // Se sono già tutte piene, aggiunge 1 in eccedenza 
          if (!updatedAny) {
            this.addToExcess(itemCode, 1);
          }

      } else {
          // MODALITÀ STANDARD (Apre il modal per inserimento manuale)
          // Suggerisce la prima riga con spazio o la prima in assoluto
          let suggestedTarget = orderLines.find(x => {
              let residuo = Number(x.Qty) - Number(x.DeliveredQty);
              return Number(x.CommitQty || 0) < residuo;
          }) || orderLines[0];

          this.itemRef = suggestedTarget;
          this.tmpQty = this.singlebarcode
            ? Number(suggestedTarget.CommitQty || 0) + 1
            : Number(suggestedTarget.CommitQty || 0);
          this.showBarCodeModal = true;
      }
      this.savedBarcode = this.barcodeSearch;
      this.barcodeSearch = '';
    },


    
    getRowProps(data) {
      const id = `${data.item.PurchaseOrdId}-${data.item.Position}`;
      const maxQty = Number(data.item.Qty) - Number(data.item.DeliveredQty || 0);
      const isCompleted = Number(data.item.CommitQty || 0) >= maxQty && maxQty > 0;
      
      let classes = [];
      if (this.highlightedRowIds.includes(id)) classes.push('highlight-flash');
      if (isCompleted) classes.push('completed-row');

      const prevItem = this.items[data.index - 1];
      if (data.index > 0 && prevItem?.PurchaseOrdId !== data.item.PurchaseOrdId) {
        classes.push('order-group-start');
      }
      
      return {
          class: classes.join(' ')
      };
    },

    triggerHighlight(item) {
      const id = `${item.PurchaseOrdId}-${item.Position}`;
      this.highlightedRowIds.push(id);
      this.$nextTick(() => {
        const el = document.querySelector('.highlight-flash');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      setTimeout(() => {
          this.highlightedRowIds = this.highlightedRowIds.filter(x => x !== id);
      }, 1000);
    },

    suppliersForItem(itemCode) {
      const map = new Map();
      this.items.filter(x => x.Item === itemCode).forEach(x => {
        if (x.Supplier && !map.has(x.Supplier)) {
          map.set(x.Supplier, { Supplier: x.Supplier, CompanyName: x.CompanyName || x.Supplier });
        }
      });
      return [...map.values()];
    },

    addToExcess(itemCode, qty, description = null, Bin = null) {
      let existing = this.excessItems.find(x => x.Item === itemCode);

      if (existing) {
        existing.CommitQty = Number(existing.CommitQty || 0) + qty;
        this.triggerHighlightExcess(existing);
        return;
      }

      const itemSuppliers = this.suppliersForItem(itemCode);

      if (itemSuppliers.length > 1) {
        this.pendingExcess = { itemCode, qty, description, Bin };
        this.excessSupplierChoice = itemSuppliers[0].Supplier;
        this.showExcessSupplierModal = true;
        return;
      }

      this.createExcessItem(itemCode, qty, description, Bin, itemSuppliers[0]?.Supplier || null);
    },

    createExcessItem(itemCode, qty, description, Bin, supplier) {
      const baseInfo = this.items.find(x => x.Item === itemCode) || { Description: '', UoM: 'PZ', UseLots: 0 };
      const newItem = {
          Item: itemCode,
          Description: description || baseInfo.Description,
          CommitQty: qty,
          Lot: '',
          ValidTo: null,
          UoM: baseInfo.UoM || 'PZ',
          UseLots: baseInfo.UseLots,
          PurchaseOrdId: null,
          Position: null,
          Riferimento: Bin,
          Matricola: '',
          Supplier: supplier || baseInfo.Supplier || null
      };
      this.excessItems = [...this.excessItems, newItem];

      this.showToast(this.$t('gm.added_to_excess'), 'warning');

      const watchStop = this.$watch('showInfoModal', (val) => {
          if (!val) {
            watchStop();
            setTimeout(() => { this.triggerHighlightExcess(newItem); }, 150);
          }
        });
    },

    confirmExcessSupplierChoice() {
      if (!this.pendingExcess) return;
      const { itemCode, qty, description, Bin } = this.pendingExcess;
      this.showExcessSupplierModal = false;
      this.createExcessItem(itemCode, qty, description, Bin, this.excessSupplierChoice);
      this.pendingExcess = null;
      if (this.tempBolApproval) {
        this.debouncedSaveTempData();
      }
    },

    triggerHighlightExcess(item) {
      const id = item.Item;
      this.highlightedExcessIds.push(id);
      this.$nextTick(() => {
        const el = document.querySelector('.highlight-flash');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      setTimeout(() => {
          this.highlightedExcessIds = this.highlightedExcessIds.filter(x => x !== id);
      }, 1000);
    },
    getExcessRowProps(data) {
      let classes = [];
      if (this.highlightedExcessIds.includes(data.item.Item)) classes.push('highlight-flash');
      return { class: classes.join(' ') };
    },

    onConfermaClick() {
      if (this.tempBolApproval === 2) {
        this.saveTempData(false);
        return;
      }

      const diffRows = this.items.filter(
        row =>
          Number(row.CommitQty || 0) > 0 &&
          Number(row.CommitQty || 0) + Number(row.DeliveredQty || 0) !== Number(row.Qty || 0)
      );
      const bomRows = this.computeBomRows();
      if (bomRows.length > 0) {
        this.bomRows = bomRows;
        this.pendingQtyDiffRows = diffRows;
        this.showBomModal = true;
        return;
      }

      if (diffRows.length > 0) {
        this.qtyDiffRows = diffRows;
        this.showQtyDiffModal = true;
        this.showSaveModal = false;
      } else {
        this.showSaveModal = true;
      }
    },

    computeBomRows() {
      const eligible = this.items.filter(item =>
        Number(item.CommitQty || 0) > 0 &&
        Array.isArray(item.bomComponents) &&
        item.bomComponents.length > 0 &&
        Number(item.Nature ?? 0) !== 0
      );

      const grouped = {};
      eligible.forEach(item => {
        if (!grouped[item.Item]) {
          grouped[item.Item] = {
            item: item.Item,
            description: item.Description,
            totalQty: 0,
            components: item.bomComponents.map(c => ({
              component: c.component,
              description: c.description,
              coefficient: c.coefficient,
              calculatedQty: 0,
              dischargeQty: 0,
              confirmed: true,
            })),
          };
        }
        grouped[item.Item].totalQty += Number(item.CommitQty || 0);
      });

      Object.values(grouped).forEach(group => {
        group.components.forEach(comp => {
          comp.calculatedQty = Math.round(group.totalQty * comp.coefficient * 10000) / 10000;
          comp.dischargeQty  = comp.calculatedQty;
        });
      });

      return Object.values(grouped);
    },

    confirmBomModal() {
      this.showBomModal = false;
      const diffRows = this.pendingQtyDiffRows;
      if (diffRows.length > 0) {
        this.qtyDiffRows = diffRows;
        this.showQtyDiffModal = true;
        this.showSaveModal = false;
      } else {
        this.showSaveModal = true;
      }
    },

    Save(goToPositioning = false)
    {
      console.log('Save method called');

      // Validate lot field if lot management is enabled
      if (this.handleLots) {
        console.log('Lot validation enabled');
        const allCommitted = [
          ...this.items.filter(i => Number(i.CommitQty || 0) > 0),
          ...this.excessItems.filter(i => Number(i.CommitQty || 0) > 0)
        ];
        
        if (allCommitted.some(i => parseInt(i.UseLots) === 1 && (!i.Lot || i.Lot.trim() === '')))
        {
          console.log('Lot validation failed');
          this.showToast(this.$t('core.lot_required_warning'), 'warning');
          return;
        }
      }

      this.isLoading = true;
      this.loadingText = this.$t('core.saving_data') + '...';

      const formatDate = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
          const year  = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day   = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        if (typeof date === 'string' && date.includes('T')) {
          return date.split('T')[0];
        }
        return date;
      };

      const getDateOnly = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
          const year  = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day   = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        return date.split('T')[0];
      };

      const supplierDateOnly = getDateOnly(this.supplierDate);
      const billingDateOnly = getDateOnly(this.BillofLadingDate);

      if (supplierDateOnly && billingDateOnly && supplierDateOnly > billingDateOnly) {
        this.showToast(this.$t('gm.supplier_date_must_be_before_billing_date') || 'Data documento fornitore deve essere minore o uguale a data registrazione bolla di carico', 'error');
        return;
      }

      const payload = {
        supplierDoc: this.supplierDoc,
        supplierDate: formatDate(this.supplierDate),
        billofLadingDate: formatDate(this.BillofLadingDate),
        rows: this.items,
        excessRows: this.excessItems,
        bomDischargeData: this.bomRows
          .map(group => ({
            item: group.item,
            components: group.components
              .filter(c => c.confirmed && Number(c.dischargeQty) > 0)
              .map(c => ({ component: c.component, dischargeQty: c.dischargeQty })),
          }))
          .filter(group => group.components.length > 0),
      };

      console.log('Payload for Save:', payload);

      axios.post(route('modules.gm.salvaRicezione'), payload)
        .then((response) => {
        this.isLoading = false;
        
        if (response.data.requiresDDTAssignment) {
          this.orphanItems = response.data.details.orphanItems || [];
          this.availableDDTs = response.data.details.availableDDTs || [];
          this.ddtAssignments = {};
          this.showDDTAssignmentModal = true;
          this.showSaveModal = false;
          return;
        }
        
        const discharge = response.data.details.componentDischarge;
        const dischargeFailed = discharge?.success === false;
        const rolledBack = discharge?.rolledBack === true;

        if (response.data.success && !rolledBack) {
          const bollaMessage = response.data.details.bolla.message;
          const pickingEnabled = response.data.details.picking.enabled;
          const pickingResults = response.data.details.picking.results || [];
          const bollaData = response.data.details.bolla.data || {};
          const ddtMapping = Object.entries(bollaData)
            .map(([ddt, b]) => {
              const docNo = b?.Data?.PurchaseDocument?.DocNo;
              return docNo ? `• DDT: ${ddt} → Protocollo: ${docNo}` : null;
            })
            .filter(Boolean);
          const DocNo = ddtMapping.length > 0 ? ddtMapping.join('\n') : '';
          
          let dischargeWarning = '';
          if (dischargeFailed) {
            dischargeWarning = '\n\n⚠️ Scarico componenti non riuscito:\n' + (discharge.message || 'Errore scarico componenti');
          }

          this.saveDone = true;
          if (pickingEnabled && pickingResults.length > 0) {
            this.showToast(bollaMessage + ' - ' + this.$t('gm.print_pickings') + dischargeWarning, dischargeFailed ? 'warning' : 'success');
            this.generatedPickings = pickingResults;
            this.showPrintPickingModal = true;
          } else {
            let finalMessage = bollaMessage;
            if (pickingEnabled && pickingResults.length === 0) {
              finalMessage += ' ' + this.$t('gm.ddt_flow.picking_no_orders');
            }
            finalMessage += dischargeWarning;
            console.log('Final message for toast:', DocNo);
            this.showToast(finalMessage,dischargeFailed ? 'warning' : 'success', DocNo);
            const firstDocId = this.getFirstPurchaseDocId(response.data.details.bolla.data);
            this.executeRedirect(goToPositioning, firstDocId, 3000);
          }

        } else {
          // Gestione errore: la bolla ha errori o è stata annullata (rollback)
          let errorMsg = response.data.details.bolla.message || "Errore nella creazione della bolla";

          if (dischargeFailed) {
            errorMsg += '\n\n⚠️ Scarico componenti non riuscito:\n' + (discharge.message || 'Errore scarico componenti');
            if (rolledBack) {
              errorMsg += '\n\n  La Bolla creata è stata annullata (rollback). Controllare la giacenza dei componenti e riprovare.';
            }
          }
          
          this.showToast(errorMsg, 'error');
        }
      })
      .catch((error) => {
        this.isLoading = false;
        this.showRequestError(error);
      });
    },
    checkBarcode(){
      if (this.tmpBarcode == this.barcodeSearch) {
        this.tmpQty++;
      }
      else{
        this.showToast(this.$t('gm.barcode_mismatched'), 'error');
        //alert('');
      }
      this.tmpBarcode = '';
    },
    showToast(message, type = 'success', extraMessage = '', duration = 3000) {

      if (this.toastTimer) {
        clearTimeout(this.toastTimer);
        this.toastTimer = null;
      }

      this.toast.message = message;
      this.toast.type    = type;
      this.toast.show    = true;

      this.modalMessage = message + (extraMessage ? '\n\n' + extraMessage : '');
      this.modalType = type;
      
      // Imposta il titolo in base al tipo
      switch(type) {
          case 'success': this.modalTitle = this.$t('core.successful_operation'); break;
          case 'error': this.modalTitle = this.$t('core.error'); break;
          case 'warning': this.modalTitle = this.$t('core.warning'); break;
          default: this.modalTitle = this.$t('core.info');
      }

      
      
      this.showInfoModal = true;
    },
    generateLot(item) {
      if (!this.lotConfig) {
        this.showToast(this.$t('gm.lot_config_not_available'), 'error');
        return;
      }
      
      const searchPattern = this.buildSearchPattern();

      const usedLots = this.items
        .filter(row => row !== item && parseInt(row.UseLots) === 1 && row.Lot && row.Lot.trim() !== '')
        .map(row => row.Lot.trim());

      axios.post(route('modules.gm.getNextLot'), { 
        prefix: searchPattern.prefix,
        suffix: searchPattern.suffix,
        item: item.Item,
        usedLots
      }).then((response) => {
        if (response.data.success) {
          const generatedLot = response.data.nextLot || response.data.lastLot;
          item.Lot = generatedLot;
          this.showToast(this.$t('gm.lot_generated') + generatedLot, 'success');
          if (this.tempBolApproval) {
            this.debouncedSaveTempData();
          }
        } else {
          this.showToast(this.$t('core.error'), 'error');
        }
      }).catch((error) => {
        this.showRequestError(error);
      });
    },
    extractProgressive(lot, prefix, suffix) {
      let progressive = lot;
      
      if (prefix && progressive.startsWith(prefix)) {
        progressive = progressive.substring(prefix.length);
      }
      
      if (suffix && progressive.endsWith(suffix)) {
        progressive = progressive.substring(0, progressive.length - suffix.length);
      }
      
      return parseInt(progressive, 10) || 0;
    },
    executeRedirect(goToPositioning, bollaId, duration = 1000) {
        if (goToPositioning) {
            setTimeout(() => {
                router.post(
                    route('modules.gm.bolleDettagli'), 
                    { ids: [bollaId] }, 
                    {
                      preserveUrl: true,
                      onHttpException: (response) => this.showRequestError({ response }),
                      onNetworkError: (error) => this.showRequestError(error)
                    }
                );
            }, duration);
        } else {
            setTimeout(() => {
                router.reload({
                  onHttpException: (response) => this.showRequestError({ response }),
                  onNetworkError: (error) => this.showRequestError(error)
                });
            }, duration);
        }
    },
    
    // Questo metodo verrà chiamato al "Chiudi" del modale
    handleModalClose() {
        this.showPrintPickingModal = false;
        // Esegue il redirect che era stato sospeso
        this.executeRedirect(this.pendingRedirect, this.lastBollaId);
    },
    findFirstAvailableProgressive(startProgressive, prefix, suffix, excludeItem) {
      let currentProgressive = startProgressive;
      
      while (this.isProgressiveUsedInRows(currentProgressive, prefix, suffix, excludeItem)) {
        currentProgressive++;
      }
      
      return currentProgressive;
    },
    isProgressiveUsedInRows(progressive, prefix, suffix, excludeItem) {
      return this.items.some(row => {
        if (row === excludeItem) return false;
        
        if (parseInt(row.UseLots) === 1 && row.Lot && row.Lot.trim() !== '') {
          const rowLot = row.Lot.trim();
          const rowProgressive = this.extractProgressive(rowLot, prefix, suffix);
          
          const matchesPrefix = !prefix || rowLot.startsWith(prefix);
          const matchesSuffix = !suffix || rowLot.endsWith(suffix);
          
          return matchesPrefix && matchesSuffix && rowProgressive === progressive;
        }
        return false;
      });
    },
    buildSearchPattern() {
      const config = this.lotConfig;
      let searchPrefix = '';
      
      if (config.prefix && config.prefix.trim() !== '') {
        searchPrefix += config.prefix.trim();
      }

      if (config.year_format === '2-digit') {
        searchPrefix += new Date().getFullYear().toString().slice(-2);
      } else if (config.year_format === '4-digit') {
        searchPrefix += new Date().getFullYear().toString();
      }
      
      if (searchPrefix.length > 0 && config.separator && config.separator !== 'none') {
        searchPrefix += config.separator;
      }
      
      const searchSuffix = (config.suffix && config.suffix.trim() !== '') ? config.suffix.trim() : '';
      
      return {
        prefix: searchPrefix,
        suffix: searchSuffix
      };
    },
    formatLot(progressive) {
      const pattern = this.buildSearchPattern();
      return pattern.prefix + progressive + pattern.suffix;
    },

    async clearExcessTable() {
      if (confirm(this.$t('gm.confirm_clear_excess'))) {
        if (this.tempBolApproval) {
          const toDelete = [...this.excessItems];
          this.excessItems = [];
          this.focusBarcodeInput();
          for (const item of toDelete) {
            try {
              await axios.post(route('modules.gm.deleteTempRow'), {
                purchase_ord_id: '_excess',
                position: item.Item,
              });
            } catch (error) {
              this.showRequestError(error);
            }
          }
        } else {
          this.excessItems = [];
          this.focusBarcodeInput();
        }
      }
    },
    async removeExcessRow(item) {
      this.excessItems = this.excessItems.filter(x => x !== item);
      this.focusBarcodeInput();
      if (this.tempBolApproval) {
        try {
          await axios.post(route('modules.gm.deleteTempRow'), {
            purchase_ord_id: '_excess',
            position: item.Item,
          });
        } catch (error) {
          this.showRequestError(error);
        }
        this.debouncedSaveTempData();
      }
    },


    commitModalQty() {
      if (!this.itemRef) return;

      const residuo = Number(this.itemRef.Qty) - Number(this.itemRef.DeliveredQty || 0);
      const qtyInserita = Number(this.tmpQty || 0);

      if (qtyInserita > residuo) {
        // Se la quantità inserita supera il residuo
        const eccedenza = qtyInserita - residuo;
        
        // Assegno il massimo possibile alla riga d'ordine
        this.itemRef.CommitQty = residuo;
        
        // Sposto il resto nelle eccedenze
        this.addToExcess(this.itemRef.Item, eccedenza, this.itemRef.Description);
      } else {
        // Caso normale entro i limiti
        this.itemRef.CommitQty = qtyInserita;
      }

      this.barcodeSearch = '';
      this.showBarCodeModal = false;

      const ref = this.itemRef;
      setTimeout(() => {
        this.triggerHighlight(ref);
      }, 300);

      if (this.tempBolApproval) {
        this.debouncedSaveTempData();
      }
    },
    handleTableQtyChange(item) {
      const residuo = Number(item.Qty) - Number(item.DeliveredQty || 0);
      if (Number(item.CommitQty) > residuo) {
        const eccedenza = Number(item.CommitQty) - residuo;
        item.CommitQty = residuo;
        this.addToExcess(item.Item, eccedenza, item.Description, item.Bin);
      }
      this.triggerHighlight(item);
      if (this.tempBolApproval) {
        this.debouncedSaveTempData();
      }
    },
    printPicking(picking) {
      const id = picking.DocumentId;
      
      if (!id) {
        this.showToast("Impossibile trovare l'ID del picking", "error");
        return;
      }

      const url = route('modules.gm.print-picking-list', { DocId: id });
      const win = window.open(url, '_blank');

      if (win) {
          win.focus();
      } else {
          this.showToast("Il browser ha bloccato il popup di stampa", "warning");
      }
    },

    printLabelPicking(picking) {
      const id = picking.DocumentId;
      
      if (!id) {
        this.showToast("Impossibile trovare l'ID del picking", "error");
        return;
      }

      const url = route('modules.gm.print-picking-label', { DocId: id });
      const win = window.open(url, '_blank');

      if (win) {
          win.focus();
      } else {
          this.showToast("Il browser ha bloccato il popup di stampa", "warning");
      }
    },
    focusBarcodeInput() {
      this.$nextTick(() => {
          this.$refs.barcodeInput?.focus({ preventScroll: true });
      });
    },
    confirmExceedModal() {
      const ref = this.itemRef;
      this.itemRef.CommitQty = this.tmpQty;
      this.showExceedModal = false;
      setTimeout(() => { this.triggerHighlight(ref); }, 300);
      if (this.tempBolApproval) {
        this.debouncedSaveTempData();
      }
    },
    rewriteReferenceLabels() {
      document.querySelectorAll('.v-data-table__td-title').forEach((el, index) => {
        if (el.innerText === this.$t('core.reference') ){
          el.classList.add('text-lg');
          el.classList.add('font-bold');

          // Modifica la colonna valore a prescindere
          el.nextSibling.classList.add('whitespace-normal');
          el.nextSibling.children[0].classList.replace('text-sm', 'text-lg');
          el.nextSibling.children[0].classList.add('font-bold');
          
          var normalizedIndex = parseInt(index / this.headers.length);
          if (this.items[normalizedIndex].Bin && !this.items[normalizedIndex].customer_id && !this.items[normalizedIndex].SaleOrdNo && !this.items[normalizedIndex].sale_ord_priority) {
            el.innerText = this.$t('core.bin');
          }
        }
      });
    },

    getFirstPurchaseDocId(bollaData) {
      if (!bollaData) return null;
      
      const firstKey = Object.keys(bollaData)[0];
      if (firstKey && bollaData[firstKey]?.Data?.PurchaseDocument?.PurchaseDocId) {
        return bollaData[firstKey].Data.PurchaseDocument.PurchaseDocId;
      }
      
      return null;
    },

    saveTempData(silent = false) {
      if (!this.tempBolApproval) return;

      if (this.tempSaveTimer) {
        clearTimeout(this.tempSaveTimer);
        this.tempSaveTimer = null;
      }

      const payload = {
        rows: this.items,
        excessRows: this.excessItems,
        tempBolHash: this.tempBolHash,
      };

      const req = axios.post(route('modules.gm.salvaBollaTemp'), payload);

      req
        .then((response) => {
          if (response.data && response.data.success === false) {
            this.showToast(
              response.data.message || 'L\'ultima lettura non è stata salvata, i dati della bolla di carico non sono più aggiornati, ricarica la pagina per continuare.',
              'error'
            );
            return;
          }

          if (!silent) {
            this.showToast('Operazione salvata, in attesa di approvazione.', 'success');
            this.executeRedirect(false, null, 1000);
          }
        })
        .catch((error) => {
          this.showRequestError(error);
        });

      return req;
    },

    debouncedSaveTempData() {
      if (!this.tempBolApproval) return;
      if (this.tempSaveTimer) clearTimeout(this.tempSaveTimer);
      this.tempSaveTimer = setTimeout(() => {
        this.saveTempData(true);
      }, 800);
    },

    completeDDTAssignment() {
      const allAssigned = this.orphanItems.every(item => this.ddtAssignments[item.id_riga_portale]);
      
      if (!allAssigned) {
        this.showToast(this.$t('gm.ddt_flow.assign_ddt_warning'), 'warning');
        return;
      }

      this.isLoading = true;
      this.loadingText = this.$t('core.saving_data') + '...';

      const payload = {
        supplierDoc: this.supplierDoc,
        supplierDate: this.supplierDate,
        rows: this.items,
        excessRows: this.excessItems,
        ddtAssignments: this.ddtAssignments
      };

      axios.post(route('modules.gm.salvaRicezione'), payload)
        .then((response) => {
          this.isLoading = false;
          this.showDDTAssignmentModal = false;

          if (response.data.success) {
            const bollaMessage = response.data.details.bolla.message;
            const pickingEnabled = response.data.details.picking.enabled;
            const pickingResults = response.data.details.picking.results || [];
            
            const bollaData = response.data.details.bolla.data || {};
            const ddtMapping = Object.entries(bollaData)
              .map(([ddt, b]) => {
                const docNo = b?.Data?.PurchaseDocument?.DocNo;
                return docNo ? `• DDT: ${ddt} → Protocollo: ${docNo}` : null;
              })
              .filter(Boolean);
            const DocNo = ddtMapping.length > 0 ? ddtMapping.join('\n') : '';

            if (pickingEnabled && pickingResults.length > 0) {
              this.showToast(bollaMessage + ' - ' + this.$t('gm.print_pickings'), "success", DocNo);
              this.generatedPickings = pickingResults;
              this.showPrintPickingModal = true;
            } else {
              let finalMessage = bollaMessage;
              if (pickingEnabled && pickingResults.length === 0) {
                finalMessage += ' ' + this.$t('gm.ddt_flow.picking_no_orders');
              }
              this.showToast(finalMessage, "success", DocNo);
              const firstDocId = this.getFirstPurchaseDocId(response.data.details.bolla.data);
              this.executeRedirect(false, firstDocId);
            }
          } else {
            let errorMsg = response.data.details.bolla.message || "Errore nella creazione della bolla";
            this.showToast(errorMsg, 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.showRequestError(error);
        });
    }

  },
  mounted() {
    if (this.defaultQtyMode === 'disabled' && !this.tempBolApproval) {
      this.items.forEach(item => {
        item.CommitQty = Number(item.Qty) - Number(item.DeliveredQty || 0);
      });
    }

    let _this = this;
    this._keyupHandler = (e) => {
      if (_this.isDisabledMode) return;
      if (document.activeElement.tagName == 'BODY') {
        if (e.key === 'Enter') {
          if (_this.showBarCodeModal && _this.singlebarcode) {
            _this.checkBarcode();
          } else {
            _this.searchItemfromBarcode();
          }
        } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
          if (_this.showBarCodeModal && _this.singlebarcode) {
            _this.tmpBarcode += e.key;
          } else {
            _this.barcodeSearch += e.key;
          }
        }
      }
    };
    document.addEventListener('keyup', this._keyupHandler);
  },

  beforeUnmount() {
    document.removeEventListener('keyup', this._keyupHandler);
    if (this.tempBolApproval) {
      if (this.tempSaveTimer) {
        clearTimeout(this.tempSaveTimer);
        this.tempSaveTimer = null;
      }
      this.saveTempData(true);
    }
  },


  
  watch: {
    'showInfoModal'(val) {
      if (!val) this.focusBarcodeInput();
    },
    'showExceedModal'(val) {
      if (!val) this.focusBarcodeInput();
    },
    'showBarCodeModal'(val) {
      if (!val) this.focusBarcodeInput();
    },
    //$parent è Layout
    '$parent.detailPopup.show'(val) {
      if (!val) {
        setTimeout(() => {
          this.focusBarcodeInput();
        }, 100);
      }
    },
  }
  
};
</script>
<style>
.highlight-flash {
  animation: flash-bg 1s ease-out;
  background-color: #fef3c7 !important; /* Giallo chiaro */
}
.completed-row {
  background-color: #dcfce7 !important; /* Verde chiaro (Tailwind green-100) */
}

@keyframes flash-bg {
  0% { background-color: #fef3c7; }
  100% { background-color: transparent; }
}


</style>

<style scoped>

@media (max-width: 639px) {
  :deep(.v-data-table__tr--mobile) {
    border-bottom: 3px solid #e5e7eb !important;
    border-top: 3px solid #e5e7eb !important;
  }
}
</style>